"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function extension(mychart, axisType) {
  var id = document.getElementById('extension');

  if (!id) {
    var div = '<div id = \'extension\' style="display:none"></div>';
    (0, _jquery.default)('html').append(div);
  }

  mychart.on('mouseover', function (params) {
    if (params.componentType === "".concat(axisType, "Axis")) {
      (0, _jquery.default)('#extension').css({
        position: 'absolute',
        color: 'rgba(0,0,0,.5)',
        'font-size': '12px',
        padding: '5px',
        display: 'inline',
        background: '#F4F4F4'
      }).text(params.value);
      (0, _jquery.default)('html').mousemove(function (event) {
        var xx = event.pageX + 10;
        var yy = event.pageY;
        (0, _jquery.default)('#extension').css('top', yy).css('left', xx);
      });
    }
  });
  mychart.on('mouseout', function (params) {
    if (params.componentType === "".concat(axisType, "Axis")) {
      (0, _jquery.default)('#extension').css('display', 'none');
    }
  });
}

var _default = extension;
exports.default = _default;